module.exports = __webpack_public_path__ + "static/Gilroy-Regular-8f2d608617198019f9d8a39752cc5ee9.woff";